import React from 'react';
import Button from '../../../components/ui/Button';

const FilterTabs = ({ activeFilter, onFilterChange, orderCounts }) => {
  const filters = [
    {
      key: 'all',
      label: 'Alle',
      count: orderCounts?.all || 0
    },
    {
      key: 'assigned',
      label: 'Zugewiesen',
      count: orderCounts?.assigned || 0
    },
    {
      key: 'in_progress',
      label: 'In Bearbeitung',
      count: orderCounts?.inProgress || 0
    },
    {
      key: 'done',
      label: 'Abgeschlossen',
      count: orderCounts?.done || 0
    }
  ];

  return (
    <div className="flex space-x-1 p-1 bg-muted rounded-lg mb-4 overflow-x-auto">
      {filters?.map((filter) => (
        <Button
          key={filter?.key}
          variant={activeFilter === filter?.key ? "default" : "ghost"}
          size="sm"
          onClick={() => onFilterChange(filter?.key)}
          className="flex-shrink-0 relative"
        >
          {filter?.label}
          {filter?.count > 0 && (
            <span className={`ml-2 px-1.5 py-0.5 text-xs rounded-full font-medium ${
              activeFilter === filter?.key 
                ? 'bg-primary-foreground text-primary' 
                : 'bg-accent text-accent-foreground'
            }`}>
              {filter?.count}
            </span>
          )}
        </Button>
      ))}
    </div>
  );
};

export default FilterTabs;